import { render } from "./ClientsMiniList.vue?vue&type=template&id=647f8bc2&scoped=true"
import script from "./ClientsMiniList.vue?vue&type=script&lang=js"
export * from "./ClientsMiniList.vue?vue&type=script&lang=js"

import "./ClientsMiniList.vue?vue&type=style&index=0&id=647f8bc2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-647f8bc2"]])

export default __exports__